import React, { Fragment, useState, useEffect } from 'react'
import {
  StyledDrawer,
  StyledCard,
  LightText,
  BoldText,
  ItemsFlex,
  LocationText,
  HighlitedCount,
  CountInfo,
  CountInfoContainer,
  FooterFlex,
  ModeText,
} from 'modules/Drive/Partials/ConfirmDriveDrawer/Style/style'
import CompanyInfo from 'modules/Drive/Partials/DrivesInfoTable/Partials/CompanyInfo'
import CarIcon from 'components/icons/CarIcon'
import LocationMarkIcon from 'components/icons/LocationMarkIcon'
import UserDefaultIcon from 'components/icons/UserDefaultIcon'
import FormSection from 'modules/Drive/Partials/ConfirmDriveDrawer/Partials/FormSection'
import Button from 'components/Button'
import moment from 'moment'
import instRequest from 'utils/instRequest'
import SuccessMessage from 'utils/SuccessMessage'
import ErrorMessage from 'utils/ErrorMessage'
import { useSelector } from 'react-redux'
import { Form } from 'antd'

const ConfirmDriveDrawer = ({
  confirmDrawer,
  setConfirmDrawer,
  selectedDrive,
  isReschedule,
  getUserCorpList,
  sendNotificationBulkEmail,
  rescheduleTemplate,
  scheduleTemplate,
}) => {
  const [confirmForm] = Form.useForm()
  const [corporateEmailList, setCorporateEmailList] = useState([])
  const institute = useSelector(state => state.auth.instituteDetails)

  useEffect(() => {
    ;(async () => {
      if (selectedDrive?.corporate?.id) {
        let responce = await getUserCorpList(selectedDrive?.corporate?.id)
        setCorporateEmailList(responce)
      }
    })()

    return () => {}
  }, [selectedDrive])

  const submitForm = data => {
    let payLoad = {
      driveId: selectedDrive?.id,
      driveStartDate: moment(data?.driveDate[0]).format('YYYY-MM-DD'),
      driveEndDate: moment(data?.driveDate[1]).format('YYYY-MM-DD'),
      driveStartTime: moment(data?.startTime).format('HH:mm'),
      driveEndTime: moment(data?.endTime).format('HH:mm'),
      hostCollegeId: selectedDrive?.hostCollegeId,
    }
    if (!isReschedule) {
      scheduleDrive(payLoad)
    } else {
      reScheduleDrive(payLoad)
    }
  }
  const scheduleDrive = async payLoad => {
    try {
      await instRequest.patch(`/institutes/drive/schedule`, payLoad)
      const final = corporateEmailList?.list?.map(item => {
        let name = item?.first_name + ' ' + item?.last_name
        const currentDate = moment().format('DD MMM YYYY')
        const template = scheduleTemplate?.templateText
          .replace('{UserName}', name)
          .replace('{institutename}', institute?.campusName)
          .replace('{rolename}', selectedDrive?.roleName)
          .replace('{dd/mmm/yyyy}', currentDate)
          .replace(
            '{drivename}',
            selectedDrive?.driveMode?.split('_')?.join(' ')?.toLowerCase()
          )
        return {
          to: item?.email,
          subject:
            scheduleTemplate?.subject ||
            'Drive Scheduled Notification - Pluginlive',
          htmlBody: template,
        }
      })
      sendNotificationBulkEmail(final)
      setConfirmDrawer(true)
      confirmForm.resetFields()
      SuccessMessage('Success..')
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
    }
  }
  const reScheduleDrive = async data => {
    let payLoad = { ...data }
    delete payLoad.driveId
    delete payLoad.hostCollegeId
    try {
      await instRequest.patch(
        `/institutes/${selectedDrive?.hostCollegeId}/drive/${selectedDrive?.id}/rescheduledrive`,
        payLoad
      )
      confirmForm.resetFields()
      const final = corporateEmailList?.list?.map(item => {
        let name = item?.first_name + ' ' + item?.last_name
        const currentDate = moment().format('DD MMM YYYY')
        const template = rescheduleTemplate?.templateText
          .replace('{UserName}', name)
          .replace('{institutename}', institute?.campusName)
          .replace('{rolename}', selectedDrive?.roleName)
          .replace('{dd/mmm/yyyy}', currentDate)
          .replace(
            '{drivename}',
            selectedDrive?.driveMode?.split('_')?.join(' ')?.toLowerCase()
          )
        return {
          to: item?.email,
          subject:
            rescheduleTemplate?.subject ||
            'Reschedule/ Request to change Drive - Pluginlive',
          htmlBody: template,
        }
      })
      sendNotificationBulkEmail(final)
      setConfirmDrawer(true)
      SuccessMessage('Success..')
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
    }
  }
  const content = () => {
    return (
      <Fragment>
        <StyledCard
          size="small"
          title={<CompanyInfo data={selectedDrive?.corporate} />}
        >
          <ItemsFlex>
            <LightText>
              <CarIcon width="16" height="17" />
              Drive Mode
            </LightText>
            <ModeText>
              {selectedDrive?.driveMode?.replace('_', ' ').toLowerCase()}
            </ModeText>
          </ItemsFlex>
          <ItemsFlex>
            <LightText>
              <LocationMarkIcon width="16" height="17" />
              Drive Location
            </LightText>
          </ItemsFlex>
          <BoldText>{selectedDrive?.hostCollegeName}</BoldText>
          <LocationText>{selectedDrive?.city}</LocationText>
        </StyledCard>
        <CountInfoContainer>
          <UserDefaultIcon />
          <CountInfo>
            <HighlitedCount>{selectedDrive?.selectedCandidate} </HighlitedCount>{' '}
            shortlisted for this drive out of {selectedDrive?.appliedCandidate}{' '}
            applied candidates
          </CountInfo>
        </CountInfoContainer>
        <FormSection
          formId="confirmDrive"
          onSubmitFormData={submitForm}
          selectedDrive={selectedDrive}
          isReschedule={isReschedule}
          form={confirmForm}
        />
      </Fragment>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Close"
          onClick={() => {
            setConfirmDrawer(false)
          }}
        />
        <Button.Primary htmlType="submit" form="confirmDrive" text="Confirm" />
      </FooterFlex>
    )
  }
  return (
    <StyledDrawer
      title={<h3>Confirm Drive</h3>}
      placement="right"
      closable={true}
      onClose={() => {
        confirmForm.resetFields()
        setConfirmDrawer()
      }}
      visible={confirmDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default ConfirmDriveDrawer
